<template>
    <div class="sports_result" v-if="u && itemDetail">
        <div class="header">
            <div class="avatar">
                <van-image :src="itemDetail.myinfo.avatar ? itemDetail.myinfo.avatar:u.userInfo.avatarurl"></van-image>
            </div>
            <div class="nickname">
                {{itemDetail.myinfo.name ? itemDetail.myinfo.name : u.userInfo.nickname}}
            </div>
        </div>

        <div class="body">
            <div class="header">
                恭喜您!
            </div>

            <div class="body">
                <mVideo :videoUrl="myinfo.mediaurl" height="3.5rem" :mediaType="itemDetail.media_type" v-if="+itemDetail.type!==5"></mVideo>
                <div class="desc">
                    您已成功参加
                    <p style="font-weight: bold;">{{ itemDetail.title }}</p>
                    <p v-if="+myinfo.state===1">
                        <template v-if=" +itemDetail.type!==5">
                             系统得分:{{ myinfo.score }}
                        </template>
                    </p>
                    <p v-else-if="+itemDetail.type===4 || +itemDetail.type===5">请耐心等待管理员审核</p>
                    <p v-else-if="+myinfo.state===3 || myinfo.state*1===4">视频审核不通过</p>
                    <!-- <p v-else>稍后请回到该页面查看分数</p> -->
                    <Button round type="primary" :color="buttonColor" block v-if="item_sub_id==4114 || item_sub_id==4113 || item_sub_id==4112"  style="color:#1989fa;" @click="godraw">抽奖</Button>
                </div>
            </div>
        </div>

        <Popup v-model="certShow">
            <van-image
                    :src="itemDetail.myinfo.cert"
                    fit="cover"
                    width="5rem"
                    style="display:flex;align-items: center;justify-content: center;"
            ></van-image>

            <div style="font-size:12px;text-align: center;margin:.2rem 0;">
                长按保存证书
            </div>
        </Popup>

        <div class="footer" v-if="itemDetail.myinfo.cert && +itemDetail.type!==5">
            <Button
                    :disabled="!itemDetail.myinfo.cert"
                    @click="certShow = true"
                    round
                    type="primary"
                    block
                    :color="buttonColor"
            >下载证书
            </Button
            >
        </div>
    </div>
    <Empty v-else description="数据加载中"/>
</template>

<style lang="less" scoped>
    @import './index.less';
</style>

<script>
    import mVideo from '@/components/mVideo/index';
    import {mapGetters} from 'vuex';
    import {Empty, Panel, Cell, Button, CellGroup, Image, Popup} from 'vant';

    export default {
        computed: {
            buttonColor() {
                let detail = this.detail;
                if (!detail) return '#ccc';
                return `${detail.tabstyle[0]['color']}`;
            },
            ...mapGetters({
                u: 'getUserInfo',
            }),
        },
        components: {
            Empty,
            Panel,
            Cell,
            Button,
            CellGroup,
            VanImage: Image,
            mVideo,
            Popup,
        },
        props: ['item_sub_id', 'sports_id'],
        data() {
            return {
                detail: '',
                itemDetail: '',
                joinList: [],
                certShow: false,
                myinfo: {},
                // u: {
                //   userInfo: {
                //     address: "",
                //     avatarurl: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJJCPmOBLhIzmHNvb9rKMMk64tyhPXnK0YdluvfwwicAUeicbZGIGLoxFzW0CWMueZl5uoTdp3ThMtw/132",
                //     city: "",
                //     continue_sign: 0,
                //     continue_signin_score: 20,
                //     country: "China",
                //     coupon_count: "0",
                //     create_time: 1564628229,
                //     enurid: "ODRaK2pTbEdDVW89",
                //     gender: 1,
                //     grand_total_point: 0,
                //     id_number: "341182***4459",
                //     id_type: null,
                //     issignin: 0,
                //     language: "zh_CN",
                //     name: "李响",
                //     nickname: "Li.",
                //     openid: "oC8Xn5fDCAqyYccwapEjfM5VT964",
                //     phone: "15858214461",
                //     province: "",
                //     role: 0,
                //     signin_score: 0,
                //     status: 1,
                //     total_point: 0,
                //     totalpoint: 0,
                //     update_time: "2021-06-23 22:01:59",
                //     urid: 4848
                //   }
                // },
            };
        },
        methods: {
            godraw() {
                this.$router.push({ name: "luckdraw", params: { acid: 1052} });
            },
            submit: function (e) {
                this.$dialog
                    .confirm({
                        title: '提示',
                        confirmButtonText: '确定提交',
                        message: '信息提交后不可修改,确定提交?',
                        showCancelButton: true,
                    })
                    .then(() => {
                        this.$api.sports
                            .submitCompare({cpgid: this.item_sub_id, registerInfo: e})
                            .then((res) => {
                                if (+res.status === 200) {
                                    this.$router.replace({
                                        name: 'result',
                                        params: {type: 'success'},
                                    });
                                }
                            });
                        // on confirm
                    })
                    .catch(() => {
                        // on cancel
                    });

                console.log(e);
            },
            init: function () {
                this.$toast.loading({
                    duration: 0,
                });
                let params = {cpgid: this.item_sub_id};
                Promise.all([
                    this.$api.sports.sportsMain(this.sports_id),
                    this.$api.sports.compareRank(params),
                    this.$api.sports.myRanks({acid:this.item_sub_id})
                ]).then((res) => {
                    let {bgstyle, id, tabstyle, introstyle, title} = res[0].data;
                    try {
                        bgstyle = JSON.parse(bgstyle);
                        tabstyle = JSON.parse(tabstyle);
                        introstyle = JSON.parse(introstyle);
                    } catch (e) {
                        console.error(e);
                    }
                    this.detail = {id, bgstyle, tabstyle, introstyle, title};
                    this.joinList = res[1]['list'];
                    delete res[1]['data']['list'];
                    if (res[1]['data']['registerform']) {
                        try {
                            res[1]['data']['registerform'] = JSON.parse(
                                res[1]['data']['registerform']
                            );
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    this.itemDetail = res[1]['data'];
                    this.myinfo = res[2]['data']['list'][0];
                    this.$toast.clear();
                });
            },
        },
        mounted() {
            this.init();
        },
    };
</script>
